export default __webpack_public_path__ + "static/media/caraid.815c46a3.mp3";